import $api from "@/core/services/ApiService";
import { User } from "@/core/services/api/interfaces/manager/User";
import ChangePassword from "@/core/services/api/interfaces/auth/ChangePassword";

class ProfileEndpoint {
  public view() {
    return $api.get("profile");
  }

  public update(profile: User) {
    return $api.put("profile", profile);
  }

  public updateAvatar(file) {
    const formData = new FormData();
    formData.append("avatar", file);

    return $api.direct({
      url: "profile/avatar",
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  public updatePassword(params: ChangePassword) {
    return $api.put("profile/password", params);
  }
}

export default ProfileEndpoint;
